<template>
  <div>
    <v-navigation-drawer
      ref="DrawerRentProtectionLegalExpensesEligibilityCheck"
      v-model="valueLocal"
      app
      right
      temporary
      class="v-navigation-drawer--width-max drawer_eligibility_check__wrapper"
    >
      <div class="drawer-container d-flex flex-column justify-space-between">
        <div
          class="drawer-header d-flex align-center justify-space-between pa-5 rounded-lg"
        >
          <h3 class="font-28 font-weight-bold">Customise your cover</h3>
          <v-btn
            icon
            @click="closeDrawer()"
            class="btn-close"
            aria-label="Close"
          >
            <v-icon size="32">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="drawer-main flex-grow-1 pa-1 pa-xl-3">
          <v-card style="height: 94%" class="pt-6">
            <v-card-title class="d-flex align-start">
              <h3
                class="black2-color dialog-title ma-0 mr-auto break-word font-weight-bold"
              >
                Rent protection & Legal expenses eligibility check
              </h3>
            </v-card-title>
            <v-card-text
              ref="eligibilityContent"
              class="mb-2 flex-grow-1"
              style="max-height: inherit"
              @scroll="onContentScroll"
            >
              <LandlordsEligibilityCoverContent
                ref="eligibilityCoverContent"
                :showNewLetQuestion="true"
                @newLetStateChanged="onNewLetStateChanged"
              />
            </v-card-text>
          </v-card>
        </div>
        <div class="drawer-footer d-flex flex-column pa-5">
          <EligibilityActions
            :disabled="!hasScrolledToBottom"
            :confirmDisabled="!hasScrolledToBottom || !isConfirmEnabled"
            block
            @confirm="agree"
            @dont-meet="cancel"
          />
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { dereference } from "@/common/transforms";
import EligibilityActions from "@/components/D2CSharedComponents/EligibilityActions.vue";
import LandlordsEligibilityCoverContent from "@/components/D2CSharedComponents/LandlordsEligibilityCoverContent.vue";
import { SDN_TEMPLATE } from "@/constants/sdn.constants";
import EligibilityScrollMixin from "@/Mixins/EligibilityScrollMixin";
import { isContentScrollable } from "@/common/eligibility";

export default {
  mixins: [EligibilityScrollMixin],
  components: {
    EligibilityActions,
    LandlordsEligibilityCoverContent,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sdnTemplate: dereference(SDN_TEMPLATE),
      isRequestError: false,
      isProcessingSDN: false,
    };
  },
  computed: {
    valueLocal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.resetState();
      }
    },
  },
  methods: {
    resetState() {
      this.newLetState = {
        answered: false,
        value: null,
        checkboxTicked: false,
      };
      this.hasScrolledToBottom = false;
      this.$nextTick(() => {
        this.$refs.eligibilityCoverContent?.resetNewLetState();
        // Double $nextTick: the first tick renders the drawer content,
        // the second ensures layout is complete so scrollHeight is accurate.
        this.$nextTick(() => {
          if (!isContentScrollable(this.$refs.eligibilityContent)) {
            this.hasScrolledToBottom = true;
          }
        });
      });
    },
    agree() {
      this.$emit("confirm", {
        confirmed: true,
        newLetOrProductTransfer: this.newLetState.value,
      });
      this.valueLocal = false;
    },
    cancel() {
      this.$emit("cancel");
      this.valueLocal = false;
    },
    closeDrawer() {
      this.$emit("cancel");
      this.valueLocal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/AppComponents/_DrawerCustomizeCover.scss";

.v-navigation-drawer--width-max {
  &.drawer_eligibility_check__wrapper {
    width: 100% !important;
    z-index: 7 !important;
  }
}
.v-sheet {
  box-shadow: none !important;
}
.v-card {
  display: flex;
  flex-direction: column;
  max-height: 97vh;
  min-height: 300px;
  position: relative;
  overflow: hidden;

  .v-card__title {
    padding: 0px 40px 24px 40px;
    .dialog-title {
      font-size: 26px !important;
      max-width: 90%;
    }
  }

  .v-card__text {
    color: $black-2 !important;
    padding: 16px 40px !important;
    max-height: calc(100vh - 420px);
    overflow-y: auto;
    flex-grow: 1;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgb(255 255 255 / 0%);
      border-radius: 10px;
      background-color: #ebebeb;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #ebebeb;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgb(255 250 250 / 30%);
      background-color: #aaa;
    }
  }

  .v-card__actions {
    padding: 24px 26px 24px 19px;
    .v-btn {
      &.v-size--x-large {
        color: $black-2;
        height: 60px !important;
        width: 100%;
      }
    }

    a {
      color: $black-2;
    }
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .v-card {
    .v-card__title {
      .dialog-title {
        font-size: 26px !important;
        max-width: 573px;
      }
    }
    .v-card__text {
      color: $black-2 !important;
      padding: 16px 37px;
    }
    .v-card__actions {
      padding: 24px 44px 24px 44px;
    }
  }
}
</style>
